export const getOrderDetails = ({ state }) => state.totalOrderDetails.orderDetails;
export const getCartDetails = ({ state }) => state.totalOrderDetails.cartDetails;
export const getInventoryDetails = ({ state }) => state.totalOrderDetails.inventoryDetails;
export const getDeviationReasons = ({ state }) => state.totalOrderDetails.deviationReasons;
export const getQcImagesData = ({ state }) => state.totalOrderDetails.qcImages;
